import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import DOMPurify from "dompurify";
import axios from "axios";
import "react-quill/dist/quill.snow.css";

const PersonalStatementTab = ({ personalstatement, campaigin_id, applicationId }) => {

  const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ color: [] }, { background: [] }], // ✅ text color + highlight
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"]
  ]
};

  const [editMode, setEditMode] = useState(false);
const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    social_media: "",
    personal_statement: "",
    skills: "",
    project_detail: "",
    q1: "",
    q2: "",
    q3: ""
  });

  // Load existing data
  useEffect(() => {
    console.log("Loaded personal statement:", personalstatement);
    if (personalstatement) {
      setFormData({
        social_media: personalstatement?.social_media || "",
        personal_statement: personalstatement?.personal_statement || "",
        skills: personalstatement?.skills || "",
        project_detail: personalstatement?.project_detail || "",
        q1: personalstatement?.q1 || "",
        q2: personalstatement?.q2 || "",
        q3: personalstatement?.q3 || ""
      });
    }
  }, [personalstatement]);

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

const handleSave = async () => {
  try {
    const token = localStorage.getItem("token"); // adjust if stored differently

    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL_strapi}/personal-statements/${applicationId}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          data: formData
        })
      }
    );

    if (!response.ok) {
      throw new Error("Failed to update personal statement");
    }

    const data = await response.json();
    console.log("Updated:", data);

    setEditMode(false);
    setShowPopup(true);
  } catch (error) {
    console.error("Error:", error);
    alert("Error saving data");
  }
};

  const renderHTML = (value) => {
    return {
      __html: DOMPurify.sanitize(value || "N/A")
    };
  };

  return (
    <div>

      {/* Toggle Button */}
     <div style={{ marginBottom: "20px" }}>
  {!editMode ? (
    <button
      onClick={() => setEditMode(true)}
      style={{
        padding: "8px 16px",
        backgroundColor: "#28a745",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "500",
        transition: "all 0.2s ease"
      }}
      onMouseOver={(e) => (e.target.style.backgroundColor = "#1e7e34")}
      onMouseOut={(e) => (e.target.style.backgroundColor = "#28a745")}
    >
      Edit
    </button>
  ) : (
    <button
      onClick={handleSave}
      style={{
        padding: "8px 16px",
        backgroundColor: "#28a745",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "500",
        transition: "all 0.2s ease",
        fontWeight:"bold"
      }}
      onMouseOver={(e) => (e.target.style.backgroundColor = "#1e7e34")}
      onMouseOut={(e) => (e.target.style.backgroundColor = "#28a745")}
    >
      Save
    </button>
  )}
</div>
      {/* SOCIAL MEDIA */}
      {campaigin_id == 3 && (
        <div>
          <strong style={{ fontSize: "19px" }}>How did you hear about this fellowship opportunity?:</strong>
          {editMode ? (
            <ReactQuill
              value={formData.social_media}
              onChange={(val) => handleChange("social_media", val)}
                          modules={modules}

            />
          ) : (
            <div style={{ fontSize: "19px" }} dangerouslySetInnerHTML={renderHTML(formData.social_media)} />
          )}
        </div>
      )}

      {/* PERSONAL STATEMENT */}
      <div>
        <strong style={{ fontSize: "19px" }}>
          {campaigin_id == 4
            ? "What motivates you in your chosen field of work? Share your most significant achievement(s) and explain how your work has made a positive impact"
            : "What motivates you in your chosen field of work? Share your most significant achievement(s) and explain how your work has made a positive impact"}
        </strong>

        {editMode ? (
          <ReactQuill
            value={formData.personal_statement}
            onChange={(val) => handleChange("personal_statement", val)}
                        modules={modules}

          />
        ) : (
          <div style={{ fontSize: "19px" }}   dangerouslySetInnerHTML={renderHTML(formData.personal_statement)} />
        )}
      </div>

      {/* SKILLS */}
      <div>
        <strong style={{ fontSize: "19px" }}>
          Why are you interested in this opportunity? State your reasons for joining the fellowship program, what you hope to gain from it, and what distinct qualities, skills, or perspectives will you bring to our cohort.
        </strong>

        {editMode ? (
          <ReactQuill
          
            value={formData.skills}
            onChange={(val) => handleChange("skills", val)}
            modules={modules}
          />
        ) : (
          <div style={{ fontSize: "19px" }} dangerouslySetInnerHTML={renderHTML(formData.skills)} />
        )}
      </div>

      {/* PROJECT DETAIL (uses social_media field) */}
      <div>
        <strong style={{ fontSize: "19px" }}>
          How do you plan to drive positive change? Describe the impact you hope to create, both within your current workspace and on a broader societal level.
        </strong>

        {editMode ? (
          <ReactQuill
            value={formData.social_media}
            onChange={(val) => handleChange("social_media", val)}
                        modules={modules}

          />
        ) : (
          <div style={{ fontSize: "19px" }}>
            {formData.social_media ? (
              <a
                href={formData.social_media}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#70BF6A', textDecoration: 'underline', wordBreak: 'break-all' }}
              >
                {formData.social_media}
              </a>
            ) : (
              <span>N/A</span>
            )}
          </div>
        )}
      </div>

      {/* PROJECT IDEAS - HIDDEN
      <h3>Project Ideas</h3>

      <div>
        <strong style={{ fontSize: "19px" }} >Challenge:</strong>
        {editMode ? (
          <ReactQuill
            value={formData.q1}
            onChange={(val) => handleChange("q1", val)}
                        modules={modules}

          />
        ) : (
          <div style={{ fontSize: "19px" }} dangerouslySetInnerHTML={renderHTML(formData.q1)} />
        )}
      </div>

      <div>
        <strong style={{ fontSize: "19px" }}>Impact:</strong>
        {editMode ? (
          <ReactQuill
            value={formData.q2}
            onChange={(val) => handleChange("q2", val)}
                        modules={modules}

          />
        ) : (
          <div style={{ fontSize: "19px" }} dangerouslySetInnerHTML={renderHTML(formData.q2)} />
        )}
      </div>

      <div>
        <strong style={{ fontSize: "19px" }}>Strategy:</strong>
        {editMode ? (
          <ReactQuill
            value={formData.q3}
            onChange={(val) => handleChange("q3", val)}
                        modules={modules}

          />
        ) : (
          <div style={{ fontSize: "19px" }} dangerouslySetInnerHTML={renderHTML(formData.q3)} />
        )}
      </div>
      */}


{showPopup && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999
    }}
  >
    <div
      style={{
        background: "#70bf6a",
        padding: "20px",
        borderRadius: "8px",
        textAlign: "center",
        minWidth: "300px"
      }}
    >
  
      <h3 style={{ color: "#fff" }}>Saved Successfully!</h3>

      <button
        onClick={() => setShowPopup(false)}
        style={{
          marginTop: "10px",
          padding: "6px 12px",
        backgroundColor: "#28a745",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer"
        }}
      >
        Close
      </button>
    </div>
  </div>
)}
    </div>
  );
  
};

export default PersonalStatementTab;